import type { PropsWithChildren } from 'react';
import type { Meta, StoryFn } from '@storybook/react';
import type { SectionNotificationProps } from 'components/SectionNotification';

import { SectionNotification } from 'components/SectionNotification';

const codeString = '<SectionNotification fullWidth={fullWidth}>{children}</SectionNotification>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/SectionNotification',
  component: SectionNotification,
  argTypes: {
    fullWidth: {
      control: 'boolean',
      default: false,
    },
  },
  parameters: {
    inspectComponent: SectionNotification,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<SectionNotificationProps>>;

const Template: StoryFn<PropsWithChildren<SectionNotificationProps>> = (args) => <SectionNotification {...args} />;

export const SectionNotificationExample = Template.bind({});
SectionNotificationExample.args = {
  fullWidth: true,
  children: 'This is an example notification',
};
